import React from 'react'
import './Modal.scss'

type ModalProps = {
  className?: string
  onClose?: () => void
}
const Modal: React.FC<ModalProps> = ({ className, onClose, children }) => {
  return (
    <div className="ModalBackground">
      <div className={`Modal ${className}`}>
        {onClose && <button className="button Close" type="button" onClick={onClose}>Close</button>}
        <div className="ModalContent">
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal